import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const DeleteSpacePortal: LoadableType<{
	spaceKey: string;
	pathname: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DeleteSpacePortal" */ './DeleteSpacePortal.tsx'))
			.DeleteSpacePortal,
	name: 'DeleteSpacePortal',
});
